/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { GovKoFssIcon16Light } from './GovKoFssIcon16Light';
import { GovKoFssIcon16Regular } from './GovKoFssIcon16Regular';
import { GovKoFssIcon16Solid } from './GovKoFssIcon16Solid';
import { GovKoFssIcon20Light } from './GovKoFssIcon20Light';
import { GovKoFssIcon20Regular } from './GovKoFssIcon20Regular';
import { GovKoFssIcon20Solid } from './GovKoFssIcon20Solid';
import { GovKoFssIcon24Regular } from './GovKoFssIcon24Regular';
import { GovKoFssIcon24Solid } from './GovKoFssIcon24Solid';
import { GovKoFssIcon32Regular } from './GovKoFssIcon32Regular';
import { GovKoFssIcon64Regular } from './GovKoFssIcon64Regular';
var sizes = {
    16: {
        light: GovKoFssIcon16Light,
        regular: GovKoFssIcon16Regular,
        solid: GovKoFssIcon16Solid,
    },
    20: {
        light: GovKoFssIcon20Light,
        regular: GovKoFssIcon20Regular,
        solid: GovKoFssIcon20Solid,
    },
    24: {
        regular: GovKoFssIcon24Regular,
        solid: GovKoFssIcon24Solid,
    },
    32: {
        regular: GovKoFssIcon32Regular,
    },
    64: {
        regular: GovKoFssIcon64Regular,
    },
};
export var GovKoFssIcon = forwardRef('GovKoFssIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
